import { useEffect, useState } from 'react'
import { signedPhotoUrl } from '../lib/photos'

/** 146. A photo-room thumbnail: the feed copy, signed (lib/photos caches it). */
export function RoomThumb({ path, alt = '', className }: { path: string; alt?: string; className?: string }) {
  const [url, setUrl] = useState<string | null>(null)
  useEffect(() => {
    let live = true
    setUrl(null)
    signedPhotoUrl(path)
      .then((u) => live && setUrl(u))
      .catch(() => {})
    return () => {
      live = false
    }
  }, [path])
  return url ? (
    <img className={className} src={url} alt={alt} loading="lazy" />
  ) : (
    <span className={className} aria-hidden="true" />
  )
}
